export const site = {
  name: "灵灵事件信息梳理站",
  shortName: "灵灵观察",
  tagline: "把碎片信息，拼成一条能看懂的脉络",
  desc: "围绕灵灵争议的公开信息进行中立梳理：本人回应要点、声明逐句解读、传闻辟谣分析与后续进展时间线。我们只整理可核验的说法，帮助读者分清事实、观点与传闻。",
  email: "editor@lingling-observe.com",
};